import { render, staticRenderFns } from "./ExtUsers.vue?vue&type=template&id=f936b1f6&"
import script from "./ExtUsers.vue?vue&type=script&lang=js&"
export * from "./ExtUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports